module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/3@2x_236346239faba5252f87d4708e9fc5ba.png";